import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

// The host redirects /home to /home/ and Angular later drops the slash. The CMS
// sees that as a page change and loads its content twice, so drop it up front.
const { pathname, search, hash } = window.location;
if (pathname.length > 1 && pathname.endsWith('/')) {
  history.replaceState(history.state, '', pathname.replace(/\/+$/, '') + search + hash);
}

// Configure XtroEdge CMS from environment variables
(window as any).__XTROEDGE_CMS_CONFIG__ = {
  clientApi: environment.cms.clientApi,
  clientHeaders: environment.cms.clientHeaders,
  licenseKey: environment.cms.licenseKey,
  highlightColor: environment.cms.highlightColor,
};

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
